export const timelineTheme = {
  eventMarker: {
    size: 'var(--rem)',
  },
  colorScheme: {
    light: {
      eventMarker: {
        borderColor: 'var(--p-primary-500)',
        content: {
          background: 'var(--transparent)',
        },
      },
      eventConnector: {
        color: 'var(--text-color-secondary)',
      },
    },
    dark: {
      eventMarker: {
        borderColor: 'var(--p-primary-500)',
        content: {
          background: 'var(--transparent)',
        },
      },
      eventConnector: {
        color: 'var(--text-color-secondary)',
      },
    },
  },
};
